import { useMutation } from "react-query";
import {
  VehiclePremiumRequestParams,
  insertVehiclePremium,
} from "store/api/api";
import { handleAxiosError } from "store/util";
import { MUTATION_KEYS } from "../queryKeys";

const insertVehiclePremiumFn = async ({
  rowVersion,
  params,
}: {
  rowVersion: string;
  params: VehiclePremiumRequestParams;
}) => {
  return await insertVehiclePremium(rowVersion, params);
};

export function useInsertVehiclePremium() {
  return useMutation(insertVehiclePremiumFn, {
    mutationKey: MUTATION_KEYS.insertVehiclePremium,

    onError: (err) => {
      handleAxiosError(err);
    },
  });
}
